import { Button, Modal } from 'react-bootstrap'
import React from 'react'

export function DeleteModal ({ show, onClose, onAccept }) {
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Apagar</Modal.Title>
            </Modal.Header>
            <Modal.Body>Voçê tem certeza que deseja apagar o item?</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Fechar</Button>
                <Button variant="danger" onClick={onAccept}>Apagar</Button>
            </Modal.Footer>
        </Modal>
    )
}